<template>
  <div class="container-fluid">
    <pre>{{this.schema.groups[0].legend}}</pre>
    <pre>{{this.schema.groups[1].fields[2].label}}</pre>
    <div class="card animated fadeIn">
      <b-form @submit.prevent="onSubmit()">
        <b-row>
          <b-col sm=4>
            <b-card border-variant="light">
              <div slot="header">
                <!-- <strong>WAN: (External Network){{this.params.network.device.lan_dev.name}}  </strong> -->
              </div>
              <div class="panel-body">
                <vue-form-generator :schema="schema" :model="device" :options="formOptions" @model-updated="onModelUpdated"></vue-form-generator>
              </div>
            </b-card>
          </b-col>
          <b-col sm=4>
            <b-card border-variant="light">
              <div slot="header">
                <strong>Details</strong>
              </div>
            </b-card>
          </b-col>
          <b-col sm=4>
            <b-card border-variant="light">
              <div slot="header">
                <strong>Task List</strong>
              </div>
              <Tasks :device="device" :changed="changed" :changes="changes"></Tasks>
            </b-card>
          </b-col>
          <b-col sm=8>
            <div class="text-center">
              <!-- TODO only activate when dirty -->
              <!-- :disabled="verrors.any()" -->
              <button class="btn btn-primary">Save</button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/devices/network/Tasks";
import VueFormGenerator from 'vue-form-generator';
// Vue.use(VueFormGenerator);
import 'vue-form-generator/dist/vfg.css';
//https://stackoverflow.com/questions/50449351/vuejs2-issue-in-vue-form-generator


export default {
  components: {
    ValidationProvider,
    Multiselect,
    Tasks,
 "vue-form-generator": VueFormGenerator.component,
  },

  props: {
    device: {
      type: Object,
      default: function() {
        return {}
      }
    },
    changed: {
      type: Array,
    },
    changes: {
      type: Object,
    },
  },
  created() {
    this.proto_value = this.device.config.network.interface.wan.proto;

  },

  data() {
    return {


      schema: {
        groups: [{
              legend: 'Device Info',
              fields: [{
                type: 'input',
                inputType: 'text',
                label: 'Name',
                model: 'name',
                id: 'user_name',
                placeholder: 'Device name',
                featured: false,
                required: false,
              }, {
                type: 'input',
                inputType: 'text',
                label: 'HostName',
                model: 'config.system.system[0].hostname',
                placeholder: 'HostName',
                hint: "System hostname.",
                help: "Hope this tooltip is helpful"
              }, ]
            }, {
              legend: 'WAN',
              fields: [{
                type: 'select',
                label: 'Connection Protocol:',
                model: 'config.network.interface.wan.proto',
                required: true,
                hideNoneSelectedText: true,
                noneSelectedText: '',
                default: "dhcp",
                values: [
                  { id: "dhcp", name: "DHCP" },
                  { id: "static", name: "Static" },
                  { id: "pppoe", name: "PPPoE" },
                ]
              }, {
                type: 'input',
                inputType: 'text',
                label: 'IP Address',
                visible: function(model) {
                  return model && model.config.network.interface.wan.proto == "static";
                },
                model: 'config.network.interface.wan.ipaddr',
                placeholder: 'IP Address',
                hint: "Static IP Address",
                help: "Hope this tooltip is helpful"
              }, {
                type: 'input',
                inputType: 'text',
                label: 'Subnet Mask',
                visible: function(model) {
                  return model && model.config.network.interface.wan.proto == "static";
                },
                model: 'config.network.interface.wan.netmask',
                placeholder: 'IP Address',
                hint: "Subnet Mask",
                help: "Hope this tooltip is helpful",
              }, {
                type: 'input',
                inputType: 'text',
                label: 'Gateway',
                visible: function(model) {
                  return model && model.config.network.interface.wan.proto == "static";
                },
                model: 'config.network.interface.wan.gateway',
                placeholder: 'IP Address',
                hint: "Subnet Mask",
                help: "Hope this tooltip is helpful",
              }, {
                type: 'input',
                inputType: 'text',
                label: 'PPPoE Username',
                visible: function(model) {
                  return model && model.config.network.interface.wan.proto == "pppoe";
                },
                model: 'config.network.interface.wan.username',
                placeholder: 'PPPoE Username',
                hint: "Subnet Mask",
                help: "Hope this tooltip is helpful",
              }, {
                type: 'input',
                inputType: 'text',
                label: 'PPPoE Password',
                visible: function(model) {
                  return model && model.config.network.interface.wan.proto == "pppoe";
                },
                model: 'config.network.interface.wan.password',
                placeholder: 'PPPoE Username',
                hint: "Subnet Mask",
                help: "Hope this tooltip is helpful",
              }, ]
            }, // end WAN
            {
              legend: 'LAN',
              fields: [{
                type: 'input',
                inputType: 'text',
                label: 'LAN IP Address',
                model: 'config.network.interface.lan.ipaddr',
                placeholder: 'IP Address',
                hint: "Static IP Address",
                help: "Hope this tooltip is helpful",
                required: true,
              }, {
                type: 'input',
                inputType: 'text',
                label: 'LAN Subnet Mask',
                model: 'config.network.interface.lan.netmask',
                placeholder: 'IP Address',
                hint: "LAN Subnet Mask",
                help: "Hope this tooltip is helpful",
                required: true,
              }, {
                type: 'input',
                inputType: 'text',
                label: 'DHCP Start',
                model: 'config.dhcp.dhcp.lan.start',
                placeholder: 'PPPoE Username',
                hint: "Lowest leased address as offset from the network address.",
                help: "Hope this tooltip is helpful",
                required: true,
              }, {
                type: 'input',
                inputType: 'text',
                label: 'DHCP Limit',
                model: 'config.dhcp.dhcp.lan.limit',
                placeholder: 'PPPoE Username',
                hint: "Maximum number of leased addresses.",
                help: "Hope this tooltip is helpful",
                required: true,
                min: 4,
                // validator: validators.string
              }, ]
            }, // end LAN
            {
              legend: '2.4GHz Wi-Fi',
              fields: [{
                type: "switch",
                label: "2.4GHz Radio",
                model: "config.wireless.wifi_device.radio0.disabled",
                multi: true,
                readonly: false,
                featured: false,
                disabled: false,
                default: true,
                textOn: "Disabled",
                textOff: "Enabled",
                valueOn: "1",
                valueOff: "0",
                visible: function(model) {
                  return model && model.config.wireless.wifi_device.radio0;
                },
              }, {
                type: 'select',
                label: '2.4 GHz Channel',
                model: 'config.wireless.wifi_device.radio0.channel',
                placeholder: 'Channel',
                hint: "Channel",
                help: "Hope this tooltip is helpful",
                hideNoneSelectedText: true,
                noneSelectedText: '',

                onChanged: function(model, newVal, oldVal, field) {
                  console.log(this);
                  // model.
                  // console.log(`old ${oldVal} new ${newVal}`, field.label,);
                   //console.log(field.model, '|', newVal,'|' ,field.label);
                 //  this.updateChanged(field.model, newVal, field.label);
                    // this.$set(this.changes, field.label, newVal );
                     // Vue.set(this.changes, field.label, newVal);

                  // console.log('new: ${newVal} , old: ${oldVal}, field: ${field}');s
//     updateChanged(par, val, nam) {
      console.log(field.model, '|', newVal, '|', field.label);
      // this.test1(field.model, newVal);
      // if proto is static => unload pppoe params
      // if proto is pppoe unload static params
      for (var i = this.changed.length - 1; i >= 0; i--) {
        if (this.changed[i].param === field.mode) {
          this.changed.splice(i, 1);
        }
      }
      this.changed.push({ param: field.model, value: newVal, name: field.label })
      this.$set(this.changes, par, val)



                },
                values: [
                  { name: 'Auto', id: "auto" },
                  { name: '1 (2412 Mhz)', id: "1" },
                  { name: '2 (2417 Mhz)', id: "2" },
                  { name: '3 (2422 Mhz)', id: "3" },
                  { name: '4 (2427 Mhz)', id: "4" },
                  { name: '5 (2432 Mhz)', id: "5" },
                  { name: '6 (2437 Mhz)', id: "6" },
                  { name: '7 (2442 Mhz)', id: "7" },
                  { name: '8 (2447 Mhz)', id: "8" },
                  { name: '9 (2452 Mhz)', id: "9" },
                  { name: '10 (2457 Mhz)', id: "10" },
                  { name: '11 (2462 Mhz)', id: "11" },
                ],
                visible: function(model) {
                  return model && model.config.wireless.wifi_device.radio0.disabled == "0";
                },
              }, {
                type: 'input',
                inputType: 'text',
                label: 'SSID',
                model: 'config.wireless.wifi_iface.default_radio0.ssid',
                placeholder: 'Wi-Fi Broadcast',
                hint: "SSID",
                help: "This is what your Wi-Fi network will broadcast as",
                visible: function(model) {
                  return model && model.config.wireless.wifi_device.radio0.disabled == "0";
                },
              }, {
                type: 'input',
                inputType: 'text',
                label: 'Passphrase',
                model: 'config.wireless.wifi_iface.default_radio0.key',
                placeholder: 'Passphrase',
                hint: "Wi-Fi Broadcast name",
                help: "Hope this tooltip is helpful",
                visible: function(model) {
                  return model && model.config.wireless.wifi_device.radio0.disabled == "0";
                },
                min: 6,
                required: true,

              }, ]
            }, // end 2.4WiFi

            {
              legend: '5GHz Wi-Fi',
              fields: [{
                type: "switch",
                label: "5GHz Radio",
                model: "config.wireless.wifi_device.radio1.disabled",
                multi: true,
                readonly: false,
                featured: false,
                disabled: false,
                default: true,
                textOn: "Disabled",
                textOff: "Enabled",
                valueOn: "1",
                valueOff: "0",
                visible: function(model) {
                  return model.config.wireless.wifi_device.radio1 && model.config.wireless.wifi_device.radio1;
                },
              }, {
                type: 'select',
                label: 'Channel',
                model: 'config.wireless.wifi_device.radio1.channel',
                placeholder: 'Channel',
                hint: "Channel",
                help: "Hope this tooltip is helpful",
                hideNoneSelectedText: true,
                noneSelectedText: '',
                values: [
                  { name: 'Auto', id: "auto" },
                  { name: '36 (5180 Mhz)', id: "36" },
                  { name: '40 (5200 Mhz)', id: "40" },
                  { name: '44 (5220 Mhz)', id: "44" },
                  { name: '48 (5240 Mhz)', id: "48" },
                  { name: '149 (5745 Mhz)', id: "149" },
                  { name: '153 (5765 Mhz)', id: "153" },
                  { name: '157 (5785 Mhz)', id: "157" },
                  { name: '161 (5805 Mhz)', id: "161" },
                  { name: '165 (5825 Mhz)', id: "165" },
                ],
                visible: function(model) {
                  return model.config.wireless.wifi_device.radio1 && model.config.wireless.wifi_device.radio1.disabled == "0";
                },
              }, {
                type: 'input',
                inputType: 'text',
                label: 'SSID',
                model: 'config.wireless.wifi_iface.default_radio0.ssid',
                placeholder: 'Wi-Fi Broadcast',
                hint: "SSID",
                help: "This is what your Wi-Fi network will broadcast as",
                visible: function(model) {
                  return model.config.wireless.wifi_device.radio1 && model.config.wireless.wifi_device.radio1.disabled == "0";
                },
              }, {
                type: 'input',
                inputType: 'text',
                label: 'Passphrase',
                model: 'config.wireless.wifi_iface.default_radio1.key',
                placeholder: 'Passphrase',
                hint: "Wi-Fi Broadcast name",
                help: "Hope this tooltip is helpful",
                visible: function(model) {
                  return model.config.wireless.wifi_device.radio1 && model.config.wireless.wifi_device.radio1.disabled == "0";
                },
                min: 6,
                required: true,

              }, ]
            }, // end 2.4WiFi




          ] //groups
      }, //schema


      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
        validateDebounceTime: 0
      },

      loading: false,
      submitted: false,
      protoOptions: [
        { text: 'DHCP', value: "dhcp" },
        { text: 'Static', value: "static" },
        { text: 'PPPoE', value: "pppoe" },
      ],
      proto_flag: false,
      proto_value: '',
    }
  },

  methods: {

test1: function(a,b){
  console.log(a , ' ', b)
},



onModelUpdated(model, schema) {
  // model and schema of update
  //console.log(model , '=', schema)
},


    // toggleDisable: function(value){
    //  return !value;

    // },

    hack1: function(value) {
      if (!this.proto_flag) {
        this.proto_value = value;
        this.proto_flag = true;
      }
    },
    mounted() {},
    updateChanged(par, val, nam) {
      console.log(par, '|', val, '|', nam);
      // if proto is static => unload pppoe params
      // if proto is pppoe unload static params
      for (var i = this.changed.length - 1; i >= 0; i--) {
        if (this.changed[i].param === par) {
          this.changed.splice(i, 1);
        }
      }
      this.changed.push({ param: par, value: val, name: nam })
      this.$set(this.changes, par, val)
    },

    onSubmit() {
      this.submitted = true;

      console.log("submitted!");
    },

  }, // end methods

};
</script>

<style>
.vue-form-generator .field-switch .label {
  background: #4DBD74
}
</style>
